export var ORIENTATION_CHANGED = 'ORIENTATION_CHANGED';
